module.exports = __webpack_public_path__ + "media/images/pc/specials/okinawa_churaumi_aquarium/bg_left-538b30c7947989773ed2664ab5879e4c.jpg";